import { HeaderFieldCellMixins } from './mixins.js';

const LocationHeaderCell = {
  mixins: [HeaderFieldCellMixins],

  template: `
    <div class="filter-field-popover">
      <div class="filter-params-container">
        <div class="input-control left-addon">
          <input type="text"
                 class='controlled-input bordered'
                 placeholder='搜索'
                 v-model.trim='keyword'
                 @keyup.enter='updateFilter' />
          <div class="addon">
            <i class="slp-search"></i>
          </div>
        </div>
      </div>
    </div>
  `
};

export { LocationHeaderCell };
